import styled from 'styled-components';
import FooterImage from "assets/home/footer-bg.png";

// import styled from "styled-components";
// import FooterImage from "common/assets/image/hosting/footer-bg.png";

const FooterWrapper = styled.footer`
  position: relative;
  background-color: #f9fbfd;
  overflow: hidden;
  background: linear-gradient(to bottom, #f7f8fd 0%, #fafbff 100%);

  @media (min-width: 576px) {
    padding-top: 130px;
    &:before {
      content: "";
      position: absolute;
      width: 104%;
      padding-bottom: 104%;
      border-top-right-radius: 11%;
      top: 14%;
      left: 0;
      pointer-events: none;
      background-color: #fff;
      transform: rotate(-6deg);
      @media (max-width: 767px) {
        padding-bottom: 150%;
      }
    }
  }

  .footer_container {
    background-repeat: no-repeat;
    background-position: center 50px;
    padding-top: 80px;
    position: relative;
    width: 100vw;
    @media (min-width: 576px) {
      background-image: url(${FooterImage?.src});
    }
    @media (max-width: 990px) {
      padding-bottom: 20px;
    }
  }
`;

const List = styled.ul``;

const ListItem = styled.li`
  a {
    color: rgba(52, 61, 72, 0.8);
    font-size: 15px;
    line-height: 36px;
    transition: all 0.2s ease;
    &:hover,
    &:focus {
      outline: 0;
      text-decoration: none;
      color: #343d48;
    }
  }
`;

const BottomRow = styled.div`
  width: 100%;
  border-top: 1px solid #e4e4e4;
  padding-top: 25px;
  color: rgba(52, 61, 72, 0.8);
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  @media (max-width: 990px) {
    display: none;
  }
`;

const BottomRowMobile = styled.div`
  width: 100%;
  border-top: 1px solid #e4e4e4;
  padding-top: 25px;
  color: rgba(52, 61, 72, 0.8);
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 0;
  flex-direction: column;
  align-items: center;
  padding-top: 28px;

  > div {
    text-align: center;
    margin-top: 10px;
  }

  div {
    font-size: 17px;
    line-height: 17px;
  }

  @media (min-width: 991px) {
    display: none;
  }
`;

export { List, ListItem, BottomRow, BottomRowMobile };

export default FooterWrapper;


// const FooterWrapper = styled.section`
//   padding: 80px 0 55px;
//   margin-top: 40px;
//   background-color: rgb(246, 249, 252);
//   @media (max-width: 480px) {
//     padding: 60px 0 30px;
//   }
//   .copyrightClass {
//     @media (max-width: 1024px) {
//       display: flex;
//       flex-direction: column;
//       justify-content: center;
//       align-items: center;
//     }
//     .copyrightMenu {
//       @media (max-width: 1024px) {
//         margin-top: 10px;
//         margin-bottom: 10px;
//         justify-content: left;
//         align-items: left;
//         margin-left: 0;
//       }
//       @media (max-width: 767px) {
//         justify-content: left;
//         align-items: left;
//         margin-left: 0;
//         margin-top: 10px;
//         margin-bottom: 10px;
//       }
//     }
//     .copyrightText {
//       @media (max-width: 1100px) {
//         margin-left: 0;
//       }
//     }
//   }
// `;

// const List = styled.ul``;

// const ListItem = styled.li`
//   a {
//     color: rgba(52, 61, 72, 0.8);
//     font-size: 14px;
//     line-height: 36px;
//     transition: all 0.2s ease;
//     &:hover,
//     &:focus {
//       outline: 0;
//       text-decoration: none;
//       color: #343d48;
//     }
//   }
// `;

// const BottomRow = styled.div`
//   width: 100%;
//   border-top: 1px solid #e4e4e4;
//   padding-top: 25px;
//   color: rgba(52,61,72,0.8);
//   display: flex;
//   justify-content: space-between;
//   margin-top: 30px;
//   padding-bottom: 20px;
//   padding-left: 15px;
//   padding-right: 15px;  
//   @media (max-width: 990px) {
//     display: none;
//   }
// `;

// const BottomRowMobile = styled.div`
//   width: 100%;
//   border-top: 1px solid #e4e4e4;
//   padding-top: 25px;
//   color: rgba(52,61,72,0.8);
//   display: flex;
//   justify-content: space-between;
//   margin-top: 30px;
//   padding-bottom: 20px;
//   padding-left: 15px;
//   padding-right: 15px; 
//   padding-bottom: 0;
//   flex-direction: column;
//   align-items: center;
//   padding-top: 28px;
  
//   > div {
//     text-align: center;
//     margin-top: 10px;
//   }

//   div {
//     font-size: 17px;
//     line-height: 17px;    
//   }

//   @media (min-width: 991px) {
//     display: none;
//   }
// `;

// export { List, ListItem, BottomRow, BottomRowMobile };

// export default FooterWrapper;
